export interface BreadcrumbEntry {
  url?: string | null
  enabled?: boolean
  enabledForSite?: boolean
  status?: string
  siteHandle?: string
}

/** Missing status data must not be treated as proof a translation is public. */
export function enabledBreadcrumbEntries(entries: BreadcrumbEntry[], siteHandle: string) {
  return entries.filter(entry => entry.enabled === true && entry.enabledForSite === true
    && entry.status === 'live' && entry.siteHandle === siteHandle)
}
